module.exports = __webpack_public_path__ + "static/accommodation-header-3a0b27ebb5a036b9cc9331643061c888.jpg";